<template>
  <div id="home" :style="{width:width}">
    <!-- 头部导航部分 -->
    <HomeHeader />
    <!-- 轮播图 -->
    <div class="banner">
      <el-carousel interval="4000">
        <el-carousel-item v-for="(item, idx) in bannerList" :key="item.contentId">
          <span @click="openLocation(`${getLink(item.link)}`, idx, 'home_banner_')" style="cursor:pointer;" v-if="item.link">
            <img :src="imageQualityHandler(item.simpleImgUrl)" alt="" width="100%" height="100%" v-if="!item.vedioGifUrl"/>
            <video v-if="item.vedioGifUrl" width="100%" height="100%" autoplay loop muted>
              <source :src="item.vedioGifUrl">
              浏览器不支持视频
            </video>
          </span>
          <span @click="goBannerDetail(item.contentId, idx, 'home_banner_')" v-else>
            <img :src="imageQualityHandler(item.simpleImgUrl)" alt="" width="100%" height="100%" v-if="!item.vedioGifUrl"/>
            <video v-if="item.vedioGifUrl" width="100%" height="100%" autoplay loop muted>
              <source :src="item.vedioGifUrl">
              浏览器不支持视频
            </video>
          </span>
        </el-carousel-item>
      </el-carousel>
      <div class="notice">
        <div class="mainBox">
          <span class="toNoticeList" @click="goto('/Notice')">
            <img style="vertical-align: text-top;" src="@/assets/img/home/horn_img.png" alt="" width="24px" height="24px">
            <span style="border-right:1px solid #ccc;display: inline-block;padding: 0 10px;height: 18px;line-height: 18px;">平台公告</span>
          </span>
          <vue-seamless-scroll style="margin-left:124px;" :data="listData " :class-option="optionSingleHeightTime" class="seamless-warp">
            <ul>
              <li v-for="item in listData" :key="item.contentId" @click="goDetil(item.contentId)">
                <span style="vertical-align: top;line-height: 38px;" v-text="item.title"></span>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
    <!-- 明星产品 -->
    <div class="product">
      <div class="product_title">明星产品</div>
      <div class="product_s_title">POPULAR PRODUCTS</div>
      <vue-seamless-scroll :data="productList" :class-option="starProductScrollClassOption" class="star_product_scroll">
        <template v-slot:left-switch>
          <el-button icon="el-icon-arrow-left" circle plain type="info"></el-button>
        </template>
        <ul class="ul-item">
          <li class="li-item" v-for="(item, idx) in productList" :key="item.contentId">
            <a @click="openLocation(`${getLink(item.link)}`, idx, 'star_entry_')" v-if="item.link" target="_blank"><img :src="item.simpleImgUrl + '?imageMogr2/quality/60'" alt=""></a>
            <img :src="item.simpleImgUrl + '?imageMogr2/quality/60'" alt="" v-else @click="goStarProduct(item.contentId, idx, 'star_entry_')"/>
          </li>
        </ul>
        <template v-slot:right-switch>
          <el-button icon="el-icon-arrow-right" circle plain type="info"></el-button>
        </template>
      </vue-seamless-scroll>
    </div>
    <!-- 服务入口 -->
    <div class="serve">
      <div class="serve_title">服务入口</div>
      <div class="serve_s_title">SERVICE ENTRY</div>
      <div class="serve_item" v-for=" (item, index) in serveList" :key="index">
        <div v-if="(index)%2 === 0">
          <div class="serve_one_left">
            <div class="item_title">{{item.title}}</div>
            <div class="item_center">{{item.description}}</div>
            <span v-if="item.link" @click="openLocation(item.link, index, 'service_entry_')"><el-button type="primary" class="professional_btn">{{item.title.indexOf("工具") == -1? '了解更多': '立即使用'}}</el-button></span>
            <span v-else @click="goStarProduct(item.contentId, index, 'service_entry_')"><el-button type="primary" class="professional_btn">{{item.title.indexOf("工具") == -1? '了解更多': '立即使用'}}</el-button></span>
          </div>
          <img :src="item.simpleImgUrl + '?imageMogr2/quality/60'" alt="" width="" height=""/>
        </div>
        <div v-else>
          <img :src="item.simpleImgUrl + '?imageMogr2/quality/60'" alt="" width="" height="" />
          <div class="serve_one_left">
            <div class="item_title">{{item.title}}</div>
            <div class="item_center">{{item.description}}</div>
            <span v-if="item.link" @click="openLocation(item.link, index, 'service_entry_')"><el-button type="primary" class="professional_btn">{{item.title.indexOf("工具") == -1? '了解更多': '立即使用'}}</el-button></span>
            <span v-else @click="goStarProduct(item.contentId, index, 'service_entry_')"><el-button type="primary" class="professional_btn">{{item.title.indexOf("工具") == -1? '了解更多': '立即使用'}}</el-button></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 最新资讯 -->
    <div class="Information">
      <div class="Information_title">最新资讯</div>
      <div class="Information_s_title">LATEST INFORMATION</div>
      <div class="Information_more" @click="goto('/information')">查看更多></div>
      <div class="Information_body">
        <div class="Information_left">
          <img style="vertical-align: middle;" src="@/assets/img/home/Information_img.png" alt="" width="" height="">
        </div>
        <ul class="Information_right" v-if="list.length > 0">
          <li v-for="item in list" :key="item" @click="goNext(item.contentId)">
            <p class="Informationitem_title">{{item.title}}</p>
            <div class="Informationitem_content" v-html="item.content"></div>
          </li>
        </ul>
        <div class="Information_right" style="text-align: center;line-height: 300px;font-size: 32px;color: #838383;" v-else>
          暂无数据
        </div>
      </div>
    </div>
    <HomeFooter style="margin-top:0;"/>
  </div>
</template>

<script>
import HomeHeader from '../../../components/HomeHeader'
import HomeFooter from '../../../components/HomeFooter'
import { getInformationList } from '@/api/modules/Information'
import vueSeamlessScroll from 'vue-seamless-scroll'
import { ticketVerify } from '@/api/modules/iam'
export default {
  name: 'Home',
  components: {
    HomeHeader,
    HomeFooter,
    vueSeamlessScroll
  },
  data() {
    return {
      list: [],
      bannerList: [],
      userInfo: null,
      productList: [],
      listData: [],
      serveList: []
    }
  },
  created() {
    this.getList()
    this.getTicketVerify()
  },
  computed: {
    optionSingleHeightTime() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },

    starProductScrollClassOption() {
      return {
        direction: 3, // 0向下 1向上 2向左 3向右
        navigation: true, // 左右方向的滚动是否显示控制器按钮，true 的时候 autoPlay 自动变为 false。
        autoPlay: false,
        switchSingleStep: 325, // 手动单步切换 step 值(px)
        switchOffset: 10 // 左右切换按钮距离左右边界的边距(默认值 30px)
        // switchDisabledClass: 'disabled' // 不可以点击状态的 switch 按钮父元素的类名
      }
    }
  },
  methods: {
    async getTicketVerify() {
      const res = await ticketVerify()
      if (res.code === 0) {
        this.userInfo = JSON.parse(localStorage.getItem('usersCurrentInfo'))
      }
    },
    // gif 不要压缩图像
    imageQualityHandler(imageUrl) {
      if (imageUrl) {
        if (imageUrl.lastIndexOf('.gif') !== -1) {
          return imageUrl
        }
        else {
          return imageUrl + '?imageMogr2/quality/60'
        }
      }
      else {
        return ''
      }
    },
    getLink(link) { // 处理http link
      return link.indexOf('http') === 0 ? link : `https://${link}`
    },
    goto(page) {
      if ((this.userInfo === null && page === '/article/Beginner') || (this.userInfo === null && page === '/article/Professional') || (this.userInfo === null && page === '/forum')) {
        this.$router.push('/login')
      }
      else {
        this.$router.push(page)
      }
    },
    async getList() {
      // 获取banner
      const bannerObj = {
        groupId: '21809'
      }
      const bannerRes = await getInformationList(bannerObj)
      if (bannerRes.code === 0) {
        this.bannerList = bannerRes.data.dataList
      }
      else {
        this.$message({
          message: bannerRes.msg,
          type: 'error'
        })
        return
      }
      // 获取公告
      const noticeObj = {
        groupId: '21811'
      }
      const noticeRes = await getInformationList(noticeObj)
      if (noticeRes.code === 0) {
        this.listData = noticeRes.data.dataList
      }
      else {
        this.$message({
          message: noticeRes.msg,
          type: 'error'
        })
        return
      }
      // 获取信息咨询
      const obj = {
        pageIndex: 1,
        pageSize: 3,
        groupId: '21813'
      }
      const res = await getInformationList(obj)
      if (res.code === 0) {
        this.list = res.data.dataList
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
        return
      }
      // 获取明星产品
      const productObj = {
        groupId: '21810'
      }
      const productRes = await getInformationList(productObj)
      if (productRes.code === 0) {
        const pd = []
        for (const dataListElement of productRes.data.dataList) {
          pd.push(dataListElement)
        }
        this.productList = pd
      }
      else {
        this.$message({
          message: productRes.msg,
          type: 'error'
        })
        return
      }
      // 获取服务入口
      const serveObj = {
        groupId: '21815'
      }
      const serveRes = await getInformationList(serveObj)
      if (serveRes.code === 0) {
        this.serveList = serveRes.data.dataList
      }
      else {
        this.$message({
          message: serveRes.msg,
          type: 'error'
        })
        return
      }
    },
    goNext(id) {
      this.$router.push({
        name: 'InformationDetail',
        query: {
          id: id
        }
      })
    },
    goDetil(id) {
      this.$router.push({
        name: 'NoticeDetail',
        query: {
          id: id
        }
      })
    },
    openLocation(link, idx, evtPrefix) {
      if ((this.userInfo === null && link === '/article/Beginner') || (this.userInfo === null && link === '/article/Professional') || (this.userInfo === null && link === '/document/0') || (this.userInfo === null && link === '/school')) {
        this.$router.push('/login')
      }
      else {
        this.$mta.up({ ac: `${evtPrefix}${idx + 1}` })
        setTimeout(() => {
          location.href = link
        }, 300)
      }
    },
    goBannerDetail(id, idx, evtPrefix) {
      this.$mta.up({ ac: `${evtPrefix}${idx + 1}` })
      setTimeout(() => {
        this.$router.push({
          name: 'ContentDetail',
          query: {
            id: id
          }
        })
      }, 300)
    },
    goStarProduct(id, idx, evtPrefix) {
      this.$mta.up({ ac: `${evtPrefix}${idx + 1}` })
      setTimeout(() => {
        this.$router.push({
          name: 'ContentDetail',
          query: {
            id: id
          }
        })
      }, 300)
    }
  }
}
</script>

<style lang="less" scoped>
#home{
  background: #FFF !important;
}
// 轮播图
.banner{
  padding-top: 70px;
  position: relative;
  // max-width: 1906px;
  margin: 0 auto;
  .notice{
    width:100%;
    position: absolute;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    z-index: 900;
    height: 38px;
    line-height: 38px;
    font-size: 16px;
    color:#fff;
    span{
      display: inline-block;
    }
  }
}
.el-carousel__item.is-animating {
  transition: all 2s ease-in-out;
}
// 明星产品
.product{
  background: #fff;
  .product_title{
    font-size: 30px;
    font-weight: 600;
    color: #2F374B;
    line-height: 46px;
    text-align: center;
    padding-top: 64px;
  }
  .product_s_title{
    font-size: 16px;
    font-weight: 400;
    color: #838383;
    text-align: center;
    margin-top:16px;
  }

  .star_product_scroll {
    width: 1300px;
    height: 100%;
    margin: 12px auto;
    overflow: hidden;
    .ul-item {
      display: flex;
      height: 100%;
      list-style: none;
      padding: 0;
      margin: 0 auto;

      .li-item {
        width: 285px;
        height: 100%;
        margin: 20px;
        transition: all .2s;
        img {
          width: 100%;
          height: 100%;
          vertical-align: middle;
        }

        &:hover {
          box-shadow: 3px 3px 8px 0 rgba(0, 36, 100, .375);
          transform: scale(1.08, 1.08);
        }
      }
    }
  }
}
// 服务入口
.serve{
  .serve_title{
    font-size: 30px;
    font-weight: 600;
    color: #2F374B;
    line-height: 46px;
    text-align: center;
    margin-top:64px;
  }
  .serve_s_title{
    font-size: 16px;
    font-weight: 400;
    color: #838383;
    text-align: center;
    margin-top:16px;
  }
  .serve_item{
    width: 1300px;
    margin: 0 auto;
    transition: all .2s;
    padding:20px;
    margin-top: 20px;
    .serve_one_left{
      width:672px;
      display: inline-block;
      .item_title{
        padding-top:108px;
        font-size: 24px;
        font-weight: 400;
        color: #2F374B;
        line-height: 33px;
        margin-left: 104px;
        margin-right: 104px;
      }
      .item_center{
        margin-top:33px;
        margin-left: 104px;
        margin-right: 104px;
        font-size: 16px;
        font-weight: 400;
        color: #838383;
        line-height: 25px;
        height: 150px;
      }
      .item_btn{
        width: 96px;
        height: 36px;
        background: #4D78FF;
        border-radius: 4px;
        margin-top:105px;
        margin-left: 104px;
      }
      .professional_btn{
        width: 96px;
        height: 36px;
        background: #FFFFFF;
        border: 1px solid #4D78FF;
        border-radius: 4px;
        margin-top:16px;
        margin-left: 104px;
        color: #4D78FF;
        padding: 0;
        transition: all .2s;
      }
      .professional_btn:hover{
        background: #4D78FF;
        border: 1px solid #FFFFFF;
        color: #FFFFFF;
      }
      .professional_auther{
        width: 96px;
        height: 36px;
        background: #FFFFFF;
        border: 1px solid #4D78FF;
        border-radius: 4px;
        margin-top:105px;
        margin-left: 104px;
        color: #4D78FF;
        padding: 0;
        transition: all .2s;
      }
      .professional_auther:hover{
        background: #4D78FF;
        border: 1px solid #FFFFFF;
        color: #FFFFFF;
      }
    }
    img{
      display: inline-block;
      vertical-align: top;
    }
  }
  .serve_item:hover{
    box-shadow: 2px 2px 10px 0 rgba(0, 36, 100, .5);
    .professional_btn{
      background: #4D78FF;
      border: 1px solid #FFFFFF;
      color: #FFFFFF;
    }
  }
}
// 最新资讯
.Information{
  background: rgb(245, 247, 250);
  padding-bottom: 134px;
  .Information_title{
    font-size: 30px;
    font-weight: 600;
    color: #2F374B;
    line-height: 46px;
    text-align: center;
    margin-top:10px;
    padding-top: 64px;
  }
  .Information_s_title{
    font-size: 16px;
    font-weight: 400;
    color: #838383;
    text-align: center;
    margin-top:16px;
  }
  .Information_more{
    cursor:pointer;
    text-underline-offset:2px;
    width: 1346px;
    text-align: right;
    height: 17px;
    font-size: 14px;
    font-weight: 400;
    text-decoration: underline;
    color: #5D82FF;
    margin: 0 auto;
    margin-top:14px;
  }
  .Information_body{
    width:1340px;
    margin:0 auto;
    margin-top:24px;
    background: #fff;
    .Information_left{
      display: inline-block;
      vertical-align: top;
    }
    .Information_right{
      display: inline-block;
      margin: 0;
      padding: 0;
      width:720px;
      li{
        cursor:pointer;
        list-style: none;
        border-bottom:1px solid #DDDDDD;
      }
      .Informationitem_title{
        margin:0;
        padding-top:40px;
        padding-left:32px;
        font-size: 20px;
        color: #2F374B;
        letter-spacing: 2px;
        white-space: nowrap;
        overflow: hidden;
      }
      .Informationitem_content{
        margin:20px 100px 25px 38px;
        font-size: 14px;
        color: #999999;
        letter-spacing: 1px;
        white-space: nowrap;
        overflow: hidden;
        height:16px;
        /deep/p{
          margin:0;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal{
  bottom:40px;
}
/deep/.el-carousel__container{
  height: calc(100vw/2.8);
}
.mainBox {
  height: 38px;
  overflow: hidden;
  display: inline-block;
  ul li{
    list-style: none;
  }
  li:hover{
    cursor:pointer;
  }
}
.toNoticeList{
  margin-left: 40px;
  cursor:pointer;
}
</style>
